import { createFileRoute } from "@tanstack/react-router"

import { AuthLayout } from "#pages/login/login-layout.tsx"

export const Route = createFileRoute("/_auth")({
  component: AuthLayout,
})
